import React from "react";
import { List, ListItem, ListItemText, Typography } from "@mui/material";

const PolicyVersions = ({ policyVersions }) => {
  return (
    <>
      <Typography variant="h5" fontWeight="bold">
        Version History
      </Typography>
      <List
        data-testid="policy-version-list"
        dense
        sx={
          policyVersions.length > 0
            ? {
                border: "1px solid #ddd",
                borderRadius: "1px",
                padding: "1px",
              }
            : {}
        }
      >
        {policyVersions.map((version, index) => {
          const { versionFull, quarter, year } = version;
          const displayVersion = versionFull ?? "";
          const cabText = quarter && year ? ` || CAB: ${quarter} ${year}` : "";

          return (
            <ListItem
              name="policy-version"
              key={index}
              sx={{ paddingTop: "1px", paddingBottom: "1px" }}
            >
              <ListItemText
                name="policy-version-details"
                primary={`${displayVersion}${cabText}`}
              />
            </ListItem>
          );
        })}
      </List>
    </>
  );
};

export default PolicyVersions;
